import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('Container')(css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    py: ['', 'big', 'big'],
    padding: ['48px 20px', '', ''],
}));
themeStyles.addBaseStyles('Title')(css({
    mb: ['xs', 'xs', 'm'],
    textAlign: ['center', '', ''],
}));
themeStyles.addBaseStyles('CopySubText')(css({
    textAlign: ['center', '', ''],
    fontSize: ['14px', '16px', '16px']
}));
themeStyles.addBaseStyles('ButtonWrapper')(css({
    mt: ['default', 'default', 'l'],
}));
themeStyles.addBaseStyles('StartNewVehicleButton')(css({
    height: 'auto',
    maxWidth: '334px',
}));
export default themeStyles;
